import type { CollapseProps } from "antd";

import Info from "./DocumentDetail";
import CategoryDetail from "./Info";

export const DocCategoryContentConstants = {
	INFO: "Doküman Bilgisi",
	CATEGORY: "Kategori Bilgisi",
};

export const DocCategoryItems: CollapseProps["items"] = [
	{
		key: "1",
		label: DocCategoryContentConstants.CATEGORY,
		children: <CategoryDetail />,
	},
	{
		key: "2",
		label: DocCategoryContentConstants.INFO,
		children: <Info />,
	}
];
